// 引入二次封装
import request from "@/utils/request.js";

// // 导出get请求的接口方法
// export function myget(params) {
//   return request({
//     url: "xxx",
//     method: "get",
//     params,
//   });
// }


// // 导出post请求的接口方法
// export function mypost(data) {
//   return request({
//     url: "xxx",
//     method: "post",
//     data,
//   });
// }



// 获取图书捐赠申请
export function bookDonateList(token,data) {
  return request({
    url: "/api/common/book_donate",
    method: "post",
    data,
    headers: { token },
  });
}


// 教书助手杂项(教研合作媒体+图书捐赠活动+合作平台)
export function teachingAssistantList(params) {
  return request({
    url: "/api/common/teaching_assistant",
    method: "get",
    params,
    
  });
}


// 教书助手综合页面彩色卡片
export function teacherCardList(params) {
  return request({
    url: "/api/common/teacher_card",
    method: "get",
    params,
    
  });
}





